import React from 'react';
import { CTAButton } from '../components/CTAButton';
import { Accordion } from '../components/Accordion';
import { BonusCard } from '../components/BonusCard';
import { ShieldCheck, Star, AlertCircle, CheckCircle2, HeartPulse, Leaf } from 'lucide-react';
export const SalesPage = () => {
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-white font-sans text-gray-800 selection:bg-[#FF8C00] selection:text-white" data-id="element-21">
      {/* SECTION 1: STICKY ANNOUNCEMENT BAR */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-[#1A1A1A] text-[#FFD700] text-center py-2 px-4 shadow-md flex flex-col sm:flex-row items-center justify-center gap-2 text-sm sm:text-base font-bold tracking-wide" data-id="element-22">
        <span data-id="element-23">🚨 ÚLTIMOS 12 CUPOS CON 80% DE DESCUENTO DISPONIBLES</span>
      </div>

      {/* SECTION 2: HERO */}
      <section className="relative pt-24 md:pt-20 lg:min-h-[90vh] flex items-center" data-id="element-24">
        {/* Split Background for Desktop */}
        <div className="absolute inset-0 flex flex-col md:flex-row z-0" data-id="element-25">
          <div className="w-full md:w-1/2 bg-[#FFFAF0] h-full" data-id="element-26"></div>
          <div className="w-full md:w-1/2 bg-white h-full" data-id="element-27"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 lg:gap-20 items-center py-16 md:py-24" data-id="element-28">
          <div className="space-y-8" data-id="element-29">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-100 text-[#FF8C00] font-semibold text-sm tracking-wide uppercase" data-id="element-30">
              <HeartPulse className="w-4 h-4" data-id="element-31" />
              Salud Digestiva Natural
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-950 leading-tight" data-id="element-32">
              Cómo Desinflamar tu Colon en 48 Horas y Recuperar tu Vientre Plano
              Naturalmente.
            </h1>
            <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-light" data-id="element-33">
              Sin gastar una fortuna en medicamentos ni dietas imposibles —
              Incluso si has vivido con gases, dolor y pesadez por años y
              sientes que nada te funciona.
            </p>
            <div className="pt-4" data-id="element-34">
              <CTAButton text="¡SÍ, QUIERO DESINFLAMAR MI COLON AHORA!" onClick={scrollToPricing} data-id="element-35" />
              <p className="mt-4 text-sm text-gray-500 flex items-center gap-2" data-id="element-36">
                <ShieldCheck className="w-4 h-4 text-[#008080]" data-id="element-37" />
                Garantía de 7 días. Pago 100% seguro.
              </p>
            </div>
          </div>
          <div className="relative mx-auto w-full max-w-md md:max-w-full" data-id="element-38">
            <div className="absolute inset-0 bg-[#008080] rounded-3xl transform rotate-3 opacity-10" data-id="element-39"></div>
            <img src="https://cdn.magicpatterns.com/uploads/jjrPueZMsSiv8frgopuEMu/portada_ebook_colon.png" alt="Libro Método Colon Feliz" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl transform transition-transform hover:-translate-y-2 duration-500" data-id="element-40" />
          </div>
        </div>
      </section>

      {/* SECTION 3: HOOK & PAIN AGITATION */}
      <section className="py-24 md:py-32 bg-white" data-id="element-41">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12" data-id="element-42">
          <p className="text-2xl md:text-3xl font-medium text-gray-900 leading-relaxed text-center" data-id="element-43">
            ¿Te ha pasado que te despiertas con el vientre plano, pero apenas
            terminas de almorzar sientes que tu ropa te aprieta tres tallas más?
          </p>

          <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-r-2xl" data-id="element-44">
            <p className="text-lg text-gray-800" data-id="element-45">
              No es solo "aire".{' '}
              <strong data-id="element-46">Es tu colon gritando por auxilio.</strong> En los próximos
              2 minutos, vas a descubrir por qué las ensaladas "saludables" que
              comes te están inflamando más y cómo puedes revertir el daño en
              solo un fin de semana.
            </p>
          </div>

          <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-47">
            <p data-id="element-48">
              Vivir con Colon Irritable en Latinoamérica es un reto. Nuestra
              comida es deliciosa, pero está llena de irritantes ocultos.
            </p>
            <ul className="space-y-4 py-4" data-id="element-49">
              <li className="flex items-start gap-3" data-id="element-50">
                <AlertCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-51" />
                <span data-id="element-52">
                  Es esa <strong data-id="element-53">vergüenza</strong> de tener que desabrochar el
                  botón del pantalón en medio de una reunión de trabajo.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-54">
                <AlertCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-55" />
                <span data-id="element-56">
                  Es el <strong data-id="element-57">miedo</strong> de salir a comer con amigos
                  porque no sabes si el baño estará cerca cuando el dolor
                  aparezca.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-58">
                <AlertCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-59" />
                <span data-id="element-60">
                  Es la <strong data-id="element-61">frustración</strong> de ir al médico y que solo
                  te digan "es estrés, toma esto" sin darte una solución real.
                </span>
              </li>
            </ul>
          </div>

          {/* Before & After Image */}
          <div className="py-8" data-id="element-62">
            <img src="https://cdn.magicpatterns.com/uploads/8RPTNKp3HTy3Uitdxx18Yt/Antes_y_despues_colon.png" alt="Antes y después de la inflamación del colon" className="w-full h-auto rounded-2xl shadow-xl" data-id="element-63" />
            <p className="text-center text-sm text-gray-500 mt-4 italic" data-id="element-64">
              La diferencia entre un colon inflamado y un colon sano.
            </p>
          </div>

          <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-65">
            <p data-id="element-66">
              Has probado de todo: fibras integrales, jugos verdes, probióticos
              caros... y sigues igual. ¿Sabes por qué?{' '}
              <strong data-id="element-67">Porque estás tratando el síntoma, no la raíz.</strong>
            </p>

            <hr className="my-12 border-gray-200" data-id="element-68" />

            <p data-id="element-69">
              <strong data-id="element-70">
                Querida amiga (o amigo) que vive en lucha constante con su
                vientre:
              </strong>
            </p>
            <p data-id="element-71">Sé exactamente cómo te sientes hoy.</p>
            <p data-id="element-72">
              Te despiertas, te miras al espejo y te sientes bien. Tu vientre
              está plano, te pones esos jeans que tanto te gustan y sales de
              casa con confianza. Pero entonces llega el almuerzo... o esa media
              tarde...
            </p>
            <p className="font-semibold text-gray-900" data-id="element-73">Y de repente, sucede.</p>
            <p data-id="element-74">
              Sientes ese primer "ruido" en las tripas. Empieza la presión. En
              menos de 30 minutos, te sientes como si te hubieran inflado con
              una bomba de aire. Tu pantalón empieza a clavarse en tu cintura.
              Tienes que ir al baño a desabrocharte el botón discretamente
              porque el dolor es insoportable.
            </p>
            <p data-id="element-75">
              Sientes vergüenza. Vergüenza de que la gente piense que tienes
              meses de embarazo cuando no es así. Vergüenza de los gases que
              aparecen en el momento menos oportuno. Pero sobre todo, sientes
              una frustración profunda.
            </p>
            <p data-id="element-76">
              Porque tú te cuidas. Comes "saludable". Llevas meses probando de
              todo:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-77">
              <li data-id="element-78">Has tomado jugos verdes que te dejaron peor.</li>
              <li data-id="element-79">Has comprado probióticos caros que parecen caramelos.</li>
              <li data-id="element-80">
                Has eliminado el gluten, los lácteos y hasta la felicidad de tu
                dieta...
              </li>
            </ul>
            <p className="font-bold text-xl text-gray-900 mt-6" data-id="element-81">
              ¿Y qué has obtenido? Nada. Sigues igual (o peor).
            </p>
          </div>

          <div className="bg-gray-50 p-8 md:p-10 rounded-3xl mt-12 border border-gray-100" data-id="element-82">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-83">
              LA GRAN MENTIRA DE LA COMIDA "SALUDABLE"
            </h3>
            <div className="space-y-6 text-lg text-gray-700" data-id="element-84">
              <p data-id="element-85">
                Aquí está la verdad que los gurús de la salud no te dicen:{' '}
                <strong data-id="element-86">
                  Muchas de las comidas que consideras "sanas" están saboteando
                  tu colon.
                </strong>
              </p>
              <p data-id="element-87">
                ¿Comes ensaladas crudas llenas de lechuga, brócoli y coliflor?
                Para un colon inflamado, eso es como frotar una herida abierta
                con una lija. La fibra insoluble es demasiado agresiva para un
                intestino que está bajo ataque.
              </p>
              <p data-id="element-88">
                ¿Tomas avena matutina cargada de leche vegetal comprada en el
                súper? Los aditivos y gomas de esas leches están destruyendo tu
                microbiota mientras lees esto.
              </p>
              <p data-id="element-89">
                En Latinoamérica, nuestra comida es deliciosa pero nuestra
                "comida moderna" es una bomba de tiempo. Aceites vegetales
                recalentados, exceso de harinas blancas disfrazadas de
                integrales y un estrés que viaja directo de tu cerebro a tu
                vientre por el nervio vago.
              </p>
              <p className="text-2xl font-bold text-center text-[#008080] pt-6" data-id="element-90">
                Tu colon no está enfermo. Tu colon está DEFENDIÉNDOSE.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4: THE REVELATION */}
      <section className="py-24 md:py-32 bg-[#FFFAF0]" data-id="element-91">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-10" data-id="element-92">
          <Leaf className="w-16 h-16 text-[#008080] mx-auto" data-id="element-93" />
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight" data-id="element-94">
            El secreto no está en dejar de comer, sino en la{' '}
            <span className="text-[#FF8C00]" data-id="element-95">"Digestibilidad Progresiva"</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-96">
            Descubrimos que al usar ingredientes específicos de nuestra región
            (como la papaya, la calabaza y técnicas de cocción criollas) podemos{' '}
            <strong data-id="element-97">"apagar" la inflamación del colon en tiempo récord.</strong>
          </p>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-98">
            No necesitas productos importados de $50 dólares. Necesitas el mapa
            correcto para usar lo que ya hay en tu cocina.
          </p>
        </div>
      </section>

      {/* SECTION 4.5: BENEFITS */}
      <section className="py-24 md:py-32 bg-[#F0FFF0]" data-id="element-99">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
          <div className="text-center mb-16" data-id="element-101">
            <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-6" data-id="element-102">
              No solo es estético, es libertad total
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-103">
              Cuando sigues el Método Colon Feliz por solo 48 horas, esto es lo
              que empiezas a experimentar:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-104">
            {/* Benefit 1 */}
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-green-100 transition-all hover:shadow-md hover:-translate-y-1" data-id="element-105">
              <div className="flex items-start gap-4 mb-4" data-id="element-106">
                <CheckCircle2 className="w-8 h-8 text-[#008080] flex-shrink-0 mt-1" data-id="element-107" />
                <div data-id="element-108">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-109">
                    👗 Adiós a la "Ropa de Emergencia"
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-110">
                    Deja de elegir tu ropa basándote en qué tanto se nota tu
                    inflamación. Vuelve a usar esos jeans ajustados, vestidos o
                    camisas que tenías guardados en el fondo del clóset "para
                    cuando estuvieras más delgada".
                  </p>
                </div>
              </div>
            </div>

            {/* Benefit 2 */}
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-green-100 transition-all hover:shadow-md hover:-translate-y-1" data-id="element-111">
              <div className="flex items-start gap-4 mb-4" data-id="element-112">
                <CheckCircle2 className="w-8 h-8 text-[#008080] flex-shrink-0 mt-1" data-id="element-113" />
                <div data-id="element-114">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-115">
                    ⚡ Explosión de Energía Real
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-116">
                    ¿Sabías que el 80% de tu energía se gasta intentando digerir
                    comida que te inflama? Al liberar a tu colon de ese
                    esfuerzo, sentirás una vitalidad que no tenías desde hace
                    años. Adiós a la fatiga mental de la tarde.
                  </p>
                </div>
              </div>
            </div>

            {/* Benefit 3 */}
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-green-100 transition-all hover:shadow-md hover:-translate-y-1" data-id="element-117">
              <div className="flex items-start gap-4 mb-4" data-id="element-118">
                <CheckCircle2 className="w-8 h-8 text-[#008080] flex-shrink-0 mt-1" data-id="element-119" />
                <div data-id="element-120">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-121">
                    🕊️ Tranquilidad en el Exterior
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-122">
                    Olvida el miedo constante de "¿Habrá un baño cerca?" cuando
                    sales a comer. Recupera la confianza de sentarte en un
                    restaurante con amigos y pedir comida sin ansiedad.
                  </p>
                </div>
              </div>
            </div>

            {/* Benefit 4 */}
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-green-100 transition-all hover:shadow-md hover:-translate-y-1" data-id="element-123">
              <div className="flex items-start gap-4 mb-4" data-id="element-124">
                <CheckCircle2 className="w-8 h-8 text-[#008080] flex-shrink-0 mt-1" data-id="element-125" />
                <div data-id="element-126">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-127">
                    🧠 Conexión Cerebro-Intestino
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-128">
                    Menos inflamación significa menos cortisol (la hormona del
                    estrés). Notarás que tu humor mejora, tu paciencia aumenta y
                    esa "niebla mental" desaparece por completo.
                  </p>
                </div>
              </div>
            </div>

            {/* Benefit 5 */}
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-green-100 transition-all hover:shadow-md hover:-translate-y-1 md:col-span-2 max-w-2xl mx-auto w-full" data-id="element-129">
              <div className="flex items-start gap-4 mb-4" data-id="element-130">
                <CheckCircle2 className="w-8 h-8 text-[#008080] flex-shrink-0 mt-1" data-id="element-131" />
                <div data-id="element-132">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-133">
                    🌙 Sueño Profundo y Reparador
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-134">
                    Al eliminar la fermentación gaseosa nocturna, tu cuerpo
                    finalmente puede entrar en sueño profundo. Despiertas
                    descansada, ligera y con el abdomen visiblemente más plano
                    cada mañana.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5: SOCIAL PROOF */}
      <section className="py-24 md:py-32 bg-white" data-id="element-135">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16" data-id="element-137">
            Personas reales, resultados reales en días
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-138">
            {/* Testimonial 1 */}
            <div className="bg-white p-8 rounded-3xl shadow-lg border border-gray-100 relative" data-id="element-139">
              <div className="flex text-[#FF8C00] mb-4" data-id="element-140">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-141" />)}
              </div>
              <p className="text-lg text-gray-700 italic mb-6" data-id="element-142">
                "Pensé que viviría inflamada para siempre. En solo 2 días con el
                protocolo SOS, mi vientre bajó 5 centímetros. ¡Por fin puedo
                usar mis jeans favoritos de nuevo!"
              </p>
              <div className="flex items-center gap-4" data-id="element-143">
                <div className="w-12 h-12 bg-[#008080] rounded-full flex items-center justify-center text-white font-bold text-xl" data-id="element-144">
                  C
                </div>
                <div data-id="element-145">
                  <h4 className="font-bold text-gray-900" data-id="element-146">Claudia M.</h4>
                  <p className="text-sm text-gray-500" data-id="element-147">México, 38 años</p>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white p-8 rounded-3xl shadow-lg border border-gray-100 relative" data-id="element-148">
              <div className="flex text-[#FF8C00] mb-4" data-id="element-149">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-150" />)}
              </div>
              <p className="text-lg text-gray-700 italic mb-6" data-id="element-151">
                "El dolor era constante. Este método me enseñó que estaba
                desayunando veneno. Hoy me despierto con energía y sin ruidos en
                la panza. ¡Gracias!"
              </p>
              <div className="flex items-center gap-4" data-id="element-152">
                <div className="w-12 h-12 bg-[#FF8C00] rounded-full flex items-center justify-center text-white font-bold text-xl" data-id="element-153">
                  A
                </div>
                <div data-id="element-154">
                  <h4 className="font-bold text-gray-900" data-id="element-155">Andrés R.</h4>
                  <p className="text-sm text-gray-500" data-id="element-156">Colombia, 45 años</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6: VALUE STACK */}
      <section className="py-24 md:py-32 bg-gray-50" data-id="element-157">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
          <div className="text-center mb-16" data-id="element-159">
            <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-6" data-id="element-160">
              El Sistema Completo de Rescate Intestinal
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-161">
              Hoy no solo te llevas un libro, te llevas el arsenal completo para
              sanar tu digestión desde la primera comida.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-162">
            <div className="order-2 lg:order-1 space-y-4" data-id="element-163">
              <BonusCard title="Ebook Principal: El Método Colon Feliz" value="$47 USD" isMain={true} data-id="element-164" />
              <BonusCard title="Bono 1: 21 Desayunos 'Victoria Matutina'" value="$27 USD" data-id="element-165" />
              <BonusCard title="Bono 2: Cenas Ligeras 'Vientre Plano'" value="$27 USD" data-id="element-166" />
              <BonusCard title="Bono 3: Guía de Antojos y Postres Sanadores" value="$27 USD" data-id="element-167" />
              <BonusCard title="Bono 4: Lista de Compras en el Mercado Local" value="$17 USD" data-id="element-168" />

              <div className="mt-8 p-6 bg-gray-900 rounded-2xl text-white text-center" data-id="element-169">
                <p className="text-lg text-gray-300 mb-2" data-id="element-170">VALOR TOTAL REAL:</p>
                <p className="text-4xl font-bold line-through text-gray-400" data-id="element-171">
                  $145.00 USD
                </p>
              </div>
            </div>

            <div className="order-1 lg:order-2" data-id="element-172">
              <img src="https://cdn.magicpatterns.com/uploads/sty93Z1PL81AZ8DPGktCNE/portada_ebook_colon_2B_bonos.png" alt="Colección completa del Método Colon Feliz en múltiples dispositivos" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-173" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7: PRICING & URGENCY */}
      <section id="pricing-section" className="py-24 md:py-32 bg-white" data-id="element-174">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-176">
            No vas a pagar $145. Ni siquiera la mitad.
          </h2>
          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-177">
            Queremos que la mayor cantidad de latinos sanen su digestión este
            año. Por eso, hemos creado esta oferta especial de lanzamiento.
          </p>

          <div className="bg-[#FFFAF0] border-2 border-[#FF8C00] rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-178">
            <div className="absolute top-0 right-0 bg-[#FF8C00] text-white text-sm font-bold px-4 py-1 rounded-bl-lg" data-id="element-179">
              OFERTA LIMITADA
            </div>
            <p className="text-2xl text-gray-700 font-medium mb-4" data-id="element-180">
              ACCESO COMPLETO HOY POR SOLO:
            </p>
            <div className="flex justify-center items-baseline gap-2 mb-8" data-id="element-181">
              <span className="text-6xl md:text-8xl font-extrabold text-gray-900" data-id="element-182">
                $6.39
              </span>
              <span className="text-2xl text-gray-500 font-medium" data-id="element-183">USD</span>
            </div>

            <div className="flex justify-center mb-8" data-id="element-184">
              <CTAButton text="¡SÍ, QUIERO DESINFLAMAR MI COLON AHORA!" href="https://pay.hotmart.com/H105419209E" className="w-full md:w-auto md:px-12 py-5 text-xl md:text-2xl" data-id="element-185" />
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-gray-600 font-medium" data-id="element-186">
              <span className="flex items-center gap-2" data-id="element-187">
                <ShieldCheck className="w-5 h-5 text-[#008080]" data-id="element-188" /> Pago Seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-189">
                <CheckCircle2 className="w-5 h-5 text-[#008080]" data-id="element-190" /> Acceso
                Inmediato
              </span>
              <span className="flex items-center gap-2" data-id="element-191">
                <Star className="w-5 h-5 text-[#008080]" data-id="element-192" /> Garantía 7 Días
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8: FAQ */}
      <section className="py-24 md:py-32 bg-gray-50" data-id="element-193">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16" data-id="element-195">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-2" data-id="element-196">
            <Accordion question="¿Necesito comprar ingredientes caros?" answer="No. Todo se encuentra en el mercado de tu barrio (papa, calabaza, pollo, frutas locales). El método está diseñado específicamente para la realidad de Latinoamérica." data-id="element-197" />
            <Accordion question="¿Es apto para vegetarianos?" answer="Sí, el método incluye opciones claras para adaptar las proteínas sin perder la efectividad del protocolo desinflamatorio." data-id="element-198" />
            <Accordion question="¿En cuánto tiempo veré resultados?" answer="La mayoría de las personas reporta menos gases y una desinflamación visible en las primeras 48 horas de aplicar la 'Digestibilidad Progresiva'." data-id="element-199" />
            <Accordion question="¿Qué pasa si no me funciona?" answer="Tienes garantía total. Si en 7 días no sientes ligereza y alivio, te devolvemos el 100% de tu dinero sin hacer preguntas." data-id="element-200" />
          </div>
        </div>
      </section>

      {/* SECTION 9: GUARANTEE */}
      <section className="py-24 md:py-32 bg-white" data-id="element-201">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202">
          <div className="border-4 border-[#008080] rounded-3xl p-8 md:p-16 bg-teal-50/30 relative" data-id="element-203">
            <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-white p-4 rounded-full border-4 border-[#008080]" data-id="element-204">
              <ShieldCheck className="w-12 h-12 text-[#008080]" data-id="element-205" />
            </div>
            <div className="text-center mt-6 space-y-6" data-id="element-206">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-207">
                Garantía de Satisfacción de 7 Días
              </h2>
              <p className="text-xl text-gray-700 leading-relaxed" data-id="element-208">
                Prueba el método, cocina las recetas y siente los resultados. Si
                no estás 100% feliz con tu transformación, te devuelvo cada
                centavo sin preguntas. <strong data-id="element-209">El riesgo es todo mío.</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 10: FINAL CLOSE & FOOTER */}
      <section className="py-24 md:py-32 bg-gray-900 text-white" data-id="element-210">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-12" data-id="element-211">
          <h2 className="text-3xl md:text-5xl font-bold leading-tight" data-id="element-212">
            Tienes dos caminos:
          </h2>

          <div className="grid md:grid-cols-2 gap-8 text-left" data-id="element-213">
            <div className="bg-gray-800 p-8 rounded-2xl border border-gray-700" data-id="element-214">
              <div className="w-12 h-12 bg-red-500/20 rounded-full flex items-center justify-center mb-6" data-id="element-215">
                <span className="text-red-500 font-bold text-xl" data-id="element-216">1</span>
              </div>
              <p className="text-lg text-gray-300" data-id="element-217">
                Seguir intentando "comer sano" por tu cuenta, sufriendo dolores
                y comprando ropa una talla más grande.
              </p>
            </div>
            <div className="bg-gray-800 p-8 rounded-2xl border border-[#FF8C00]" data-id="element-218">
              <div className="w-12 h-12 bg-[#FF8C00]/20 rounded-full flex items-center justify-center mb-6" data-id="element-219">
                <span className="text-[#FF8C00] font-bold text-xl" data-id="element-220">2</span>
              </div>
              <p className="text-lg text-gray-300" data-id="element-221">
                Invertir hoy menos de lo que cuesta una cena afuera y recuperar
                el control de tu salud para siempre.
              </p>
            </div>
          </div>

          <div className="pt-8 flex justify-center" data-id="element-222">
            <CTAButton text="¡SÍ, QUIERO EL MÉTODO COLON FELIZ + TODOS LOS BONOS!" href="https://pay.hotmart.com/H105419209E" className="w-full md:w-auto md:px-10 py-6 text-xl" data-id="element-223" />
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-950 py-12 border-t border-gray-800" data-id="element-224">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-225">
          <p className="text-gray-500 text-sm mb-4" data-id="element-226">
            Este producto no sustituye el consejo médico profesional. Consulte a
            su médico antes de comenzar cualquier programa de salud.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-227">
            <a href="#" className="hover:text-white transition-colors" data-id="element-228">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-229">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-230">
              Contacto
            </a>
          </div>
          <p className="text-gray-600 text-xs mt-8" data-id="element-231">
            &copy; {new Date().getFullYear()} Método Colon Feliz. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
};